import React, { PureComponent } from "react";
import { CAMS_URL, FETCH_URL } from "../../constants/ServerLinks";
import axios from "axios";
import Cookies from "universal-cookie";
import Header from "../../components/header/Header";
import Info from "./Info";
import { withRouter } from "react-router-dom";

class InfoContainer extends PureComponent {
  constructor() {
    super();

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;

    this.cookies = new Cookies();
    this.token = this.cookies.get("token");

    this.state = {
      navLinks: [
        {
          name: "Instructor",
          href: "",
          icon: "--",
          target: "_",
        },
        {
          name: "Back",
          href: "",
          icon: "iconBack",
          target: "_back",
        },
        {
          name: "Documentation",
          href: "/info",
          icon: "iconInfo",
          target: "_self",
        },
        // {
        //     name: 'Frank Batten School',
        //     href: 'https://batten.virginia.edu',
        //     icon: 'iconBatten',
        //     target: '_blank',
        // },
        // {
        //     name: 'CLSG',
        //     href: 'https://www.clsgbatten.org',
        //     icon: 'iconClsg',
        //     target: '_blank',
        // },
      ],
    };
  }

  onNavLinkClick = (e, nav) => {
    e.preventDefault();

    if (nav.target === "_self") {
      window.open(nav.href, "_self");
    } else if (nav.target === "_blank") {
      window.open(nav.href, "_blank");
    } else if (nav.target === "_back") {
      this.props.history.goBack();
    }
  };

  fetchUserNameAndPhoto = () => {
    axios
      .all([
        axios.get(this.camsURL + "/api/auth/user", {
          headers: { Authorization: `Token ${this.token}` },
        }),
        // axios.get(this.camsURL + "/api/v1/users/photo/", {
        //   headers: { Authorization: `Token ${this.token}` },
        // }),
      ])
      .then(
        axios.spread((detailsResponse, photoResponse) => {
          // console.group("WorldControlPanel:fetchUserNameAndPhoto");
          // console.log(detailsResponse);
          // console.log(photoResponse);
          // console.groupEnd();
          if (detailsResponse.status === 200) {
            let rolesInfo = detailsResponse.data;
            // let photoInfo = photoResponse.data;

            this.setState(() => {
              return {
                navLinks: this.state.navLinks.map((item) => {
                  if (item.name === "Instructor") {
                    item.name =
                      rolesInfo.first_name + " " + rolesInfo.last_name;
                    item.bg = "";
                    return item;
                  } else {
                    return item;
                  }
                }),
              };
            });
          }
        })
      )
      .catch((error) => {
        console.log(error.response);
      });
  };

  authUser = () => {
    axios
      .get(this.camsURL + "/api/auth/user", {
        headers: { Authorization: `Token ${this.token}` },
      })
      .then((response) => {
        // console.group("WorldControlPanel:authUser");
        // console.log(response.data);
        // console.groupEnd();
        if (response.data.success) {
          this.fetchUserNameAndPhoto();
        } else {
          window.location.replace("/");
        }
      })
      .catch((error) => {
        console.log(error.response);
        window.location.replace("/");
      });
  };

  componentDidMount = () => {
    this.authUser();
  };

  render() {
    return (
      <div>
        <Header />

        <div className="nav__wrap">
          <ul className="nav__list">
            {this.state.navLinks.map((nav, index) => (
              <li key={index}>
                <button onClick={(e) => this.onNavLinkClick(e, nav)}>
                  <span
                    className={`nav__icon ${nav.icon}`}
                    style={
                      nav.icon === "--"
                        ? {
                            backgroundImage: `url(${nav.bg})`,
                            backgroundSize: "cover",
                            padding: "10",
                            borderRadius: "50%",
                            cursor: "default",
                          }
                        : {}
                    }
                  />
                  <span
                    className="nav__link"
                    style={nav.icon === "--" ? { cursor: "default" } : {}}
                  >
                    {nav.name}
                  </span>
                  <span className="nav__border" />
                </button>
              </li>
            ))}
          </ul>
        </div>

        <Info display="show" isInstructor={true} />
      </div>
    );
  }
}

export default withRouter(InfoContainer);
